import { Services } from '@sigma-frontend-libs/commons'

import { sourceItems } from '@/utils'

import generatorSearch from '@/components/generator/search'
import { tariffInputFilter, tariffOutputFilter } from '@/components/services/tariffs/utils'
import templateLegacy from '@/components/templates/legacy'

import render from './render'

export default {
  name: Services.tariffs,

  mixins: [ sourceItems(Services.tariffs) ],

  components: {
    'search-generator': generatorSearch({
      name: Services.tariffs,

      inputFilterForCreateButton: tariffInputFilter,
      outputFilterForCreateButton: tariffOutputFilter,

      find: {
        defaultFilter: {
          isActive: true,
          source: undefined
        }
      }
    }),

    'legacy-template': templateLegacy({
      name: Services.tariffs,

      inputFilter: tariffInputFilter,
      outputFilter: tariffOutputFilter,

      find: false,
      get: {
        params: {
          query: {
            $scope: [ 'Owner' ]
          }
        }
      },
      update: {
        params: {
          query: {
            $scope: [ 'Owner' ]
          }
        }
      },
      remove: {
        redirect: true
      }
    })
  },

  render
}
